<template>
  <div>
    <section class="daily-section-web mt-5">
      <a href="/bulletIn/list">
      <div class="daily-head-base">
        <h6>📢 Urgent Sales</h6>
          <h2 class="marketprice_text-run">
          Contact sellers directly for immediate purchase opportunities || 
        <span class="color" v-for="item in market" :key="item.market_price_id">
          {{ item.product_name }}
          
          <span class="material-symbols-outlined">₹</span>
          {{ item.price }}/{{ selectedLanguage === 'en'
                  ? item.quantity_type
                  : item.quantity_type_tamil }}
          <span
            class="material-symbols-outlined"
          ><img src="../assets/images/footer-component/icon.svg" loading="lazy" alt="geo-alt"></span>
          {{
            selectedLanguage === "en"
            ? item.district_name
            : item.district_tn_name 
          }} on {{ formatDate(item.created_at) }} ||
        </span>
          </h2>
      </div>
      </a>
    </section>
  </div>
</template>

<script>
import { en, ta } from "@/translations";

export default {
  props: ["selectedLanguage"], // Receive the selectedLanguage prop from App.vue

  data() {
    return {
      market: []
    };
  },
  computed: {
    translations() {
      return this.selectedLanguage === "en" ? en : ta;
    },
  },
  mounted() {
  fetch("https://vaiyal-app.herokuapp.com/simplelistbulletin")
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "success") {
        this.market = data.data;
      }
    })
    .catch((error) => {
      console.error("Error fetching bulletin data:", error);
    });
},
  methods: {
    formatDate(date) {
      const dateObject = new Date(date);
      const day = String(dateObject.getDate()).padStart(2, "0");
      const month = String(dateObject.getMonth() + 1).padStart(2, "0");
      const year = String(dateObject.getFullYear()).slice(-2);
      return `${day}-${month}-${year}`;
    }
  }
};
</script>

<style>
@import url("/src/components/RunComponenet.scss");

</style>